module.exports = __webpack_public_path__ + "static/media/k.913e47e9.png";